import type { CommunityComment } from '~/interfaces/community/comment';

/** Type guard for unknown API responses — validates the shape before narrowing to CommunityComment. */
export const isCommunityComment = (value: unknown): value is CommunityComment => {
  if (typeof value !== 'object' || value === null) return false;
  const comment = value as { id?: unknown; tiptap_state?: unknown; author?: unknown };
  return (
    typeof comment.id === 'string' &&
    typeof comment.tiptap_state === 'object' &&
    comment.tiptap_state !== null &&
    typeof comment.author === 'object' &&
    comment.author !== null
  );
};
